// StatusPill — the only status-pill component in the app.
//
// Four tones (red / amber / green / blue) match the design tokens in
// tailwind.config.js (status.red-bg / red-text, etc.). Use pillStatus
// .toneFor(domain, status) to pick the tone, then pillStatus.labelFor
// (domain, status) for the label. Centralizing the tone tables keeps
// every screen rendering identical pills.
//
// Style spec (locked by design):
//   - rounded-full
//   - px-2 py-0.5
//   - text-[11px] font-medium tabular-nums
//   - NO uppercase, NO tracking-wide, NO font-medium/bold
//
// `icon` is optional and renders to the left of the children. Good for
// a checkmark on completed/done states. Pass plain text or a ReactNode.
export default function StatusPill({ tone = 'blue', icon, children, className = '' }) {
  const toneClass = TONE_CLASS[tone] || TONE_CLASS.blue
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium tabular-nums ${toneClass} ${className}`}
    >
      {icon ? <span aria-hidden="true">{icon}</span> : null}
      {children}
    </span>
  )
}

// Single source of truth for tone → bg+text class string. Mapped to
// the status-* tokens declared in tailwind.config.js.
const TONE_CLASS = {
  red:   'bg-status-red-bg text-status-red-text',
  amber: 'bg-status-amber-bg text-status-amber-text',
  green: 'bg-status-green-bg text-status-green-text',
  blue:  'bg-status-blue-bg text-status-blue-text',
}
